import React from 'react';
const IconArrowConnect = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12ZM15 6.5L18.5 10L15 13.5V11H11V9H15V6.5ZM5.5 14L9 17.5V15H13V13H9V10.5L5.5 14Z" fill="#666666"/>
</svg>
);
};
export default IconArrowConnect;